/**
 * @license
 * @copyright Copyright Motili Inc., 2023 All Rights Reserved
 */

import { useNavigate } from 'react-router-dom';
import Welcome from './Welcome';

export default function WelcomePage() {
    const navigate = useNavigate();
    const handleNextClick = () => navigate('/contractor/getStarted');

    return <Welcome handleNextClick={handleNextClick} />;
}
